import { getTPID } from './thematic-path.js'

const getJsonData = (id) => {
    const scriptSelector = `script#${id}`
    const $scriptEl = document.querySelector(scriptSelector)
    console.log(scriptSelector)
    try {
        return JSON.parse($scriptEl.textContent);
    } catch (err) { // if we have not valid json or dont have it
        return null;
    } 
}


const buildQuery = (tpid) => {
    const url = new URL(`${document.location.origin}/wp-json/oce/v1/thematic_pathway_name/`)
    
    // console.log('gonna send', tpid)
    url.searchParams.append('tpid', tpid)
    
    console.log('request:', url.href)
    
    return url
}

/* global fetch */
const betterFetch = async (url) => {
    return fetch(url)
      .then(response => {
        if (response.ok) return response.json()
        else {
          /* An error has occured */
          return response.json()
            .catch(() => {
              /* Couldn't parse the JSON */
              return response.status
            })
            .then(({message}) => {
              /* Got valid JSON with error response, use it */
              console.error(`Got valid JSON with error response "${message || response.status}". (URL: ${url})`)
              // throw new Error(message || response.status);
              return {httpCode: response.status, errorMessage: message}
            })
        }
      })
      .catch(error => error)
}

const queryThematicPathName = async (tpid) => {
    const url = buildQuery(tpid)
    const response = await betterFetch(url)
    console.log(response)
    
    return response.data
}

const dataLayer = () => {
    // console.log('dataLayer.js')
    
    window._mtm = window._mtm || [];
    
    // footer newsletter
    const $newsletterForm = document.querySelector('.newsletter__form-enclosure > form')
    $newsletterForm.addEventListener('submit', () => {
        window._mtm.push({
            'event': 'newsletter_subscribe',
        });
    })
    
    const $resourceDownloadBtn = document.querySelector('.resource__dl-btn[data-download-button]')
    const $downloadLangSelect = document.querySelector('#download-lang')
    
    // console.log($resourceDownloadBtn)
    // console.log($downloadLangSelect)
    
    $resourceDownloadBtn?.addEventListener('click', async () => {
        
        const download_resource_event = getJsonData('datalayer-download-resource')
        // console.log('retrieved JSON data:', download_resource_event)
        
        const thematicPathwayID = getTPID()
        if (thematicPathwayID) {
            download_resource_event.if_pathway = true
            download_resource_event.thematic_pathway = await queryThematicPathName(thematicPathwayID) 
        } else {
            download_resource_event.if_pathway = false
            download_resource_event.thematic_pathway = null
        }
        
        download_resource_event.langue = $downloadLangSelect.value
        
        console.log('resource downloaded. Sent event:', download_resource_event)
        window._mtm.push(download_resource_event);
    })
    
    
    // Event page CTA
    // const ctas = [ ...document.querySelectorAll('.oce-form-push__cta') ]
}


export { dataLayer }